import { RootState } from './../../app/store';

export const selectTournament = (state: RootState) => state.tournament;
export const selectTournamentData = (state: RootState) => state.tournament?.data;
export const selectTournamentStats = (state: RootState) => state.tournament?.stats;
